/**
 * Pure helpers for category-based recommendations (unit-tested without Angular TestBed).
 */
export function collectCartCategoryIds(
  items: Array<{ product?: { categoryId?: number | null } | null }> | null | undefined
): number[] {
  if (!items?.length) {
    return [];
  }
  const ids = new Set<number>();
  for (const item of items) {
    const id = item.product?.categoryId;
    if (typeof id === 'number' && id > 0) {
      ids.add(id);
    }
  }
  return [...ids];
}

export function mergeRecommendedProducts(
  groups: Array<Array<{ id: number }>>,
  excludeIds: Iterable<number>,
  maxProducts: number
): Array<{ id: number }> {
  const excluded = new Set(excludeIds);
  const seen = new Set<number>();
  const merged: Array<{ id: number }> = [];
  for (const group of groups) {
    for (const product of group) {
      if (excluded.has(product.id) || seen.has(product.id)) {
        continue;
      }
      seen.add(product.id);
      merged.push(product);
      if (merged.length >= maxProducts) {
        return merged;
      }
    }
  }
  return merged;
}
